import { SpeakToTextDto } from 'types';
import { MESSAGE_SENDER_NAME } from 'utils/constants';

export const calculateHeightSpeakToText = (
  message: SpeakToTextDto,
  isFirstOfSender?: boolean,
  maxWidth = 300,
  isShowName: boolean = true
): number => {
  if (!message) return 0;
  const contentDiv = document.createElement('div');
  let height = 0;
  /** padding bottom bao gồm height của giờ gửi */
  contentDiv.className = `relative min-w-[70px] whitespace-pre-wrap break-words rounded-lg px-3 pb-8 pt-2 text-left text-sm`;
  contentDiv.style.maxWidth = `${maxWidth}px`;
  contentDiv.innerHTML = message.content || '';

  document.body.appendChild(contentDiv);

  height = contentDiv.offsetHeight;
  document.body.removeChild(contentDiv);

  /** Hiển thị tên người gửi trong chat nhóm ở tin nhắn đầu tiền của người gửi */
  const senderNameHeight = isShowName && isFirstOfSender ? MESSAGE_SENDER_NAME : 0;

  return height + senderNameHeight;
};
